import { HttpBackend, HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { config } from '../../config';
import { MemberQuery } from '../../../account/member/member.query';
import { AuthService } from '../../../user/services/auth.service';
import { getLcidByCultureCode, LCID } from './i18n/locales';
import { inject } from '@angular/core';

export class FGBTranslationLoader implements TranslateLoader {
  private handler: HttpBackend = inject(HttpBackend);
  private http: HttpClient = new HttpClient(this.handler);
  private authService: AuthService = inject(AuthService);
  private memberQuery: MemberQuery = inject(MemberQuery);

  /**
   * Used to get the data for the current language
   *
   * @param lang current language using the language code
   */
  getTranslation(lang: string): Observable<any> {
    let clubId = config.defaultClubId;
    if (this.authService.isAuthenticated()) {
      clubId = this.memberQuery.getClubId() || config.defaultClubId;
    }

    let lcid = getLcidByCultureCode(lang);
    if (lcid === undefined) {
      lcid = parseInt(config.defaultLcid) as LCID;
    }

    return this.http.get(`${config.baseApiUrl}/api/content/?clubId=${clubId}&lcid=${lcid}`);
  }
}
